<!-- Enter address -->
<div class="row mt-2">
  <div class="col-lg-5">
    <div class="col-lg-12">
      <label style="font-weight:bold">Enter address</label>
    </div>
    <div class="col-lg-12 ">
      <input class="input  "  class="pac-container" type="text" [(ngModel)]="autocompleteInput" placeholder="Search Location" #addresstext
      style="padding: 8px 8px; border: 1px solid #ccc; width: 400px">
    </div>
  </div>
  <div class="col-lg-7">
    <div class="col-lg-12 mt-3">
      <label style="font-weight:bold"></label>
    </div>
    <div class="col-lg-12 ">
      <button type="button" class="btn blue-btn btn-sm "   style="float:right"
      [disabled]="autocompleteInput==null || autocompleteInput==undefined || autocompleteInput==''"
          (click)="CopyAddresstoPrePopulate()">Copy Address</button>
    </div>
  </div>
</div>
<br>
<br>
<br>
<!-- IFrame -->
<!-- <div class="row mt-2 ml-1 mr-1" *ngIf="trustUrl!=null">
  <div class="col-lg-12">
     <div id="loader" class="loader"></div> 
      <iframe  id="myIframe" (load)="myLoadEvent()" frameborder="0" style="width:100%; height:88vh;border: groove;" [src]="trustUrl">
      </iframe>
      
  </div>
</div> -->


<div class="row pt-4" >
  <div class="col-lg-12">
    <div id="map" style="height: 400px;"></div>
  </div>
</div>

